module.exports = __webpack_public_path__ + "static/media/none-address.96d5eec4.png";